import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../.';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
  mutation RemoveItemToTagMutation($tagId: ID!, $itemId: ID!, $isGlobal: Boolean) {
    removeItemToTag(tagId: $tagId, itemId: $itemId, isGlobal: $isGlobal) {
      ok
      error
    }
  }
`;

export default ({
  tagId,
  itemId,
  isGlobal
}, done) => {
  const variables = {
    tagId,
    itemId,
    isGlobal
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ removeItemToTag }) => basicMutationOnCompleted(removeItemToTag, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
